import * as interviews from './services/InterviewService';

export default function loadForm(type, callback, preActionCallback) {
    // init vars
    let form = document.querySelector('form');

    // init form event
    if (!form) {
        return;
    }

    form.addEventListener('submit', event => {

        event.preventDefault();

        // ignore other forms
        if (event.target.id === 'interview-cancel-form') {
            return;
        }

        document.getElementById('form-submit').disabled = true;
        document.getElementById('form-submit').classList.add('opacity-50');

        if (preActionCallback && typeof preActionCallback === "function") {
            preActionCallback();
        }

        let data = {
            type: type,
            attributes: {}
        };

        form.querySelectorAll('[name]')
            .forEach(field => {
                // skip fields starting with _
                if (field.name.match(/^_/)) {
                    return;
                }

                // we only need the checked values for checkbox/radio
                if (
                    (field.type == 'checkbox') ||
                    (field.type == 'radio')
                ) {
                    // multiple ?
                    if (field.name.match(/\[\]$/)) {
                        let nameSingle = field.name.replace('[]', '');

                        if (typeof data.attributes[nameSingle] == 'undefined') {
                            data.attributes[nameSingle] = [];
                        }

                        if (field.checked) {
                            data.attributes[nameSingle].push(field.value);
                        }
                    }

                    // default ?
                    else {
                        if (field.checked) {
                            data.attributes[field.name] = field.value;
                        }
                    }
                } else {
                    // else use the default value
                    let fieldName = field.name.split('-');

                    if (fieldName.length === 3 && fieldName[1] != '0') {
                        if (typeof data.attributes[fieldName[0]] === 'undefined') {
                            data.attributes[fieldName[0]] = [];
                        }

                        if (typeof data.attributes[fieldName[0]][fieldName[1] - 1] === 'undefined') {
                            data.attributes[fieldName[0]].splice(fieldName[1] - 1, 0, {});
                        }

                        data.attributes[fieldName[0]][fieldName[1] - 1][fieldName[2]] = field.value || '';
                    } else if (fieldName.length === 1) {
                        data.attributes[[fieldName[0]]] = (field.name === 'job_id' ? +field.value : field.value) || '';
                    }
                }

            });

        if (callback && typeof callback === "function") {
            callback(data, form);
        }
    });

    // handle cancel
    let cancelInterview = document.getElementById('cancel-interview');

    if (cancelInterview) {
        cancelInterview.addEventListener('click', event => {
            event.preventDefault();

            window.dispatchEvent(new Event('open-cancel-interview'))
        })
    }


    let cancelling = false;
    let cancelInterviewForm = document.getElementById('interview-cancel-form');

    if (cancelInterviewForm) {
        cancelInterviewForm.addEventListener('submit', event => {
            if (cancelling) return;
            cancelling = true;

            event.preventDefault();

            let data = {
                type: 'interviews',
                attributes: {}
            };

            cancelInterviewForm.querySelectorAll('[name]')
                .forEach(field => {
                    data.attributes[field.name] = field.value;
                });

            interviews.cancelInterview(Jobtoolz.api.invitationId, data)
                .then(response => {
                    if (response.status === 200) {
                        // show success message
                        return window.dispatchEvent(new Event('close-cancel-interview'))
                    }
                })
                .then(() => {
                    // reload page
                    window.location.reload();
                });
        })
    }

    // handle reschedule
    let rescheduleInterview = document.getElementById('reschedule-interview');

    if (rescheduleInterview) {
        rescheduleInterview.addEventListener('click', event => {
            event.preventDefault();

            window.dispatchEvent(new Event('open-reschedule-interview'))
        })
    }


    let rescheduling = false;
    let rescheduleInterviewForm = document.getElementById('interview-reschedule-form');

    if (rescheduleInterviewForm) {
        rescheduleInterviewForm.addEventListener('submit', event => {
            if (rescheduling) return;
            rescheduling = true;

            event.preventDefault();

            let data = {
                type: 'interviews',
                attributes: {}
            };

            rescheduleInterviewForm.querySelectorAll('[name]')
                .forEach(field => {
                    data.attributes[field.name] = field.value;
                });

            interviews.rescheduleInterview(Jobtoolz.api.invitationId, data)
                .then(response => {
                    if (response.status === 200) {
                        // show success message
                        return window.dispatchEvent(new Event('close-reschedule-interview'))
                    }
                })
                .then(() => {
                    // reload page
                    window.location.reload();
                });
        })
    }
}
